module.exports = "/images/arrow-right.fac54ad2c7d8466bc2f954f9ddead6d8.svg";